import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import MuiBox from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { getBorderMock } from '../../../utils/getBorderMock.js';
import 'date-fns';
import Hint from '../../Hint/Hint.js';

const getColor = ({ theme, disabled, inactive, isInitialState, error, modifiedManually, }) => {
    if (disabled) {
        return {
            general: theme.palette.N30.main,
            rootHover: theme.palette.N30.main,
            focusWithin: theme.palette.N30.main,
            inputHover: theme.palette.N30.main,
            inputHoverFocus: theme.palette.N30.main,
        };
    }
    else if (error) {
        return {
            general: theme.palette.error.main,
            rootHover: theme.palette.error.main,
            focusWithin: theme.palette.N10.main,
            inputHover: theme.palette.error.main,
            inputHoverFocus: theme.palette.primary.main,
        };
    }
    else if (isInitialState) {
        return {
            general: theme.palette.N30.main,
            rootHover: theme.palette.N30.main,
            focusWithin: theme.palette.N10.main,
            inputHover: theme.palette.primary.dark,
            inputHoverFocus: theme.palette.primary.main,
        };
    }
    else if (modifiedManually) {
        return {
            general: theme.palette.warning.main,
            rootHover: theme.palette.N10.main,
            focusWithin: theme.palette.N10.main,
            inputHover: theme.palette.primary.main,
            inputHoverFocus: theme.palette.primary.main,
        };
    }
    else if (inactive) {
        return {
            general: theme.palette.N20.main,
            rootHover: theme.palette.N10.main,
            focusWithin: theme.palette.N10.main,
            inputHover: theme.palette.primary.main,
            inputHoverFocus: theme.palette.primary.main,
        };
    }
    else {
        return {
            general: theme.palette.N10.main,
            rootHover: theme.palette.N10.main,
            focusWithin: theme.palette.N10.main,
            inputHover: theme.palette.primary.main,
            inputHoverFocus: theme.palette.primary.main,
        };
    }
};
const _TimeInputContainer = styled(MuiBox, {
    shouldForwardProp: prop => !['hint', 'inactive', 'disabled', 'error', 'modifiedManually', 'isInitialState', 'size', 'withBorder'].includes(prop),
}) `
  transition: color ${({ theme }) => theme.transitions.duration.fast} linear,
    background-color ${({ theme }) => theme.transitions.duration.fast} linear,
    border ${({ theme }) => theme.transitions.duration.fast} linear,
    fill ${({ theme }) => theme.transitions.duration.fast} linear;
  border-radius: 4px;
  display: flex;
  align-items: center;
  position: relative;
  border: ${({ theme, withBorder }) => withBorder && `1px solid ${theme.palette.N40.main}`};
  ${({ theme }) => getBorderMock(theme)}
  ${({ theme, inactive, disabled, error, isInitialState, modifiedManually, size }) => {
    const colors = getColor({ theme, inactive, disabled, error, isInitialState, modifiedManually });
    return `
      font-style: ${isInitialState ? 'italic' : 'normal'};
      height: ${size === 'small' ? 20 : 30}px;
      background-color: ${inactive ? 'transparent' : theme.palette[disabled ? 'N80' : 'N70'].main};
      opacity: ${disabled && !inactive ? '0.4' : '1'};
      color: ${colors.general};
      cursor: ${disabled ? 'not-allowed' : 'pointer'}; 
      .MuiInputBase-input , .MuiInputBase-root {
        color: ${colors.general};
      }
      &:focus-within {
        cursor: text; 
        font-style: normal;
        background-color: ${theme.palette.N70.main};
        &:after {
          border-color: ${theme.palette.primary.main};
        }
        .MuiInputBase-input , .MuiInputBase-root{
          color: ${colors.focusWithin};
        }
        color: ${colors.focusWithin};
        div:hover { 
          .MuiInputBase-input, .MuiInputBase-root {
            color: ${colors.inputHoverFocus};
          }
          color: ${colors.inputHoverFocus};
        }
        > div .MuiInputBase-root .MuiInputBase-input { 
          cursor: text;
        }
      }
      &:after {
        ${error && !inactive && !disabled && `border-color: ${theme.palette.error.main};`}
      }
      > div .MuiInputBase-root .MuiInputBase-input { 
        cursor: ${disabled ? 'not-allowed' : 'pointer'};
      }
      div:hover { 
        .MuiInputBase-input, .MuiInputBase-root {
          color: ${colors.inputHover};
        }
        color: ${colors.inputHover};
      }
      &:hover:not(:focus-within) {
        background-color: ${!disabled && theme.palette[error ? 'N70' : 'N60'].main};
        color: ${colors.rootHover};
        > div .MuiInputBase-root .MuiInputBase-input {
          cursor: ${disabled && 'not-allowed !important'}; 
        }
      }
    `;
}};
`;
const TimeInputContainer = (_a) => {
    var { hint, hintDuration } = _a, rest = __rest(_a, ["hint", "hintDuration"]);
    const hideHint = !hint || (!rest.disabled && !rest.error && !rest.isInitialState);
    return (jsx(Hint, Object.assign({ title: hint, duration: hintDuration, disableFocusListener: true, disabled: hideHint }, { children: jsx(_TimeInputContainer, Object.assign({}, rest)) })));
};

export { TimeInputContainer as default };
//# sourceMappingURL=TimeInputContainer.js.map
